import getMuiTheme from 'material-ui/styles/getMuiTheme';

const theme = getMuiTheme({
  fontFamily: '"Gotham Rounded SSm A", "Gotham Rounded SSm B", sans-serif',
  palette: {
    primary1Color: 'hsl(204, 100%, 39%)',
    primary2Color: 'hsl(322, 76%, 76%)',
    textColor: 'hsl(0, 0%, 20%)',
  },
});

export default theme;



// WEBPACK FOOTER //
// ./src/components/theme.js